import type { Paddle, PricePreviewParams } from '@paddle/paddle-js';
import { useEffect, useState } from 'react';
import { paidPro, paidStarter } from './paidTiers';

export type PaddlePrices = Record<string, string>;

export function usePaddlePrices(
  paddle: Paddle | undefined,
  country: string | undefined,
): { prices: PaddlePrices; loading: boolean } {
  const [prices, setPrices] = useState<PaddlePrices>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const priceIds = [paidStarter, paidPro]
      .flatMap((tier) => [tier.priceId.month, tier.priceId.year])
      .filter((id) => id !== '');
    if (!paddle || priceIds.length === 0) {
      setLoading(false);
      return;
    }

    const items: PricePreviewParams['items'] = priceIds.map((priceId) => ({
      priceId,
      quantity: 1,
    }));

    const request: PricePreviewParams = {
      items,
      ...(country ? { address: { countryCode: country } } : {}),
    };

    setLoading(true);
    paddle
      .PricePreview(request)
      .then((preview) => {
        const next: PaddlePrices = {};
        for (const item of preview.data.details.lineItems) {
          next[item.price.id] = item.formattedTotals.total;
        }
        setPrices(next);
      })
      .catch((err: unknown) => {
        console.warn('[exis] failed to load Paddle prices', err);
        setPrices({});
      })
      .finally(() => setLoading(false));
  }, [paddle, country]);

  return { prices, loading };
}
